<template>
  <section
    v-loading.fullscreen.lock="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    class="top-navbar bg-transparent !z-[0] !pt-1.5"
    id="topBarHeader"
  >
    <template
      v-if="
        this.brandingInfo &&
        this.brandingInfo.session_info &&
        this.brandingInfo.session_info.timeOut
      "
    >
      <v-idle
        style="display: none"
        @idle="onIdle"
        @remind="onRemind"
        :loop="true"
        :reminders="[60, 90]"
        :wait="10"
        :duration="this.brandingInfo.session_info.timeOutSeconds * 60"
        :events="events"
      />
    </template>

    <div>
      <el-row type="flex" align="middle" class="topbar-appearence">
        <el-col :xs="10" :md="8">
          <div class="top-navbar-left-menu">
            <ul>
              <li>
                <div class="company-logo" v-if="!getIsMobile">
                  <a href="/dashboard">
                    <img
                      v-if="this.getSingleCompanyLogo"
                      :src="logo"
                      alt="Nimble logo"
                      style="max-height: 26px; max-width: 140px"
                    />
                    <template v-else>
                      <img
                        v-if="appSetting.APPLICATION_TYPE == 'ESIGNS'"
                        src="@/assets/img/logo-white.svg"
                        alt="Nimble Logo"
                        class="img-fluid"
                      />
                      <img v-else src="@/assets/img/Logo-Eagle.png" alt="Logo" class="img-fluid" />
                    </template>
                  </a>
                </div>
                <div class="company-logo" v-if="!isHorMenu && getIsMobile">
                  <a href="/dashboard">
                    <img
                      v-if="this.getSingleCompanyLogo"
                      :src="logo"
                      alt="Nimble logo"
                      :style="getIsMobile ? 'height:30px;margin-top:5px;width:90%' : ''"
                      class="img-fluid"
                    />
                    <img
                      v-else
                      src="@/assets/img/logo-white.svg"
                      alt="Nimble logo"
                      :style="getIsMobile ? 'height:30px;margin-top:5px;width:90%' : ''"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div
                  class="company-logo"
                  v-if="getIsMobile"
                  style="display: flex; align-items: center"
                >
                  <a href="/dashboard" style="display: inline-block">
                    <img
                      v-if="this.getSingleCompanyLogo"
                      :src="logo"
                      alt="Nimble logo"
                      style="
                        max-height: 35px;

                        max-width: 130px;

                        width: auto;

                        height: auto;
                      "
                    />
                    <template v-else>
                      <img
                        v-if="appSetting.APPLICATION_TYPE == 'ESIGNS'"
                        src="@/assets/img/logo-white.svg"
                        alt="Nimble Logo"
                        style="
                          max-height: 35px;

                          max-width: 130px;

                          width: auto;

                          height: auto;
                        "
                      />
                      <img
                        v-else
                        src="@/assets/img/Logo-Eagle.png"
                        alt="Logo"
                        style="
                          max-height: 35px;

                          max-width: 130px;

                          width: auto;

                          height: auto;
                        "
                      />
                    </template>
                  </a>
                </div>
              </li>
              <li>
                <div class="toggle-menu-animation">
                  <div
                    v-if="isHorMenu"
                    id="burger"
                    :class="getIsOpen ? 'active' : ''"
                    @click="sendMessageToParent"
                  >
                    <button type="button" class="burger-button" title="Menu">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 18 18"
                        fill="currentColor"
                        class="text-black-900"
                      >
                        <path
                          d="M11.25 0.9375H6.75C2.67525 0.9375 0.9375 2.67525 0.9375 6.75V11.25C0.9375 15.3247 2.67525 17.0625 6.75 17.0625H11.25C15.3247 17.0625 17.0625 15.3247 17.0625 11.25V6.75C17.0625 2.67525 15.3247 0.9375 11.25 0.9375ZM10.6875 15.9375H6.75C3.2895 15.9375 2.0625 14.7105 2.0625 11.25V6.75C2.0625 3.2895 3.2895 2.0625 6.75 2.0625H10.6875V15.9375ZM15.9375 11.25C15.9375 14.5155 14.8433 15.7905 11.8125 15.924V2.076C14.8433 2.2095 15.9375 3.4845 15.9375 6.75V11.25ZM6.3975 6.6825L8.3175 8.6025C8.36975 8.65467 8.4112 8.71664 8.43948 8.78484C8.46776 8.85305 8.48232 8.92616 8.48232 9C8.48232 9.07384 8.46776 9.14695 8.43948 9.21516C8.4112 9.28336 8.36975 9.34533 8.3175 9.3975L6.3975 11.3175C6.29136 11.4199 6.14925 11.4765 6.00176 11.4752C5.85428 11.4738 5.71322 11.4146 5.60898 11.3103C5.50473 11.2059 5.44564 11.0648 5.44443 10.9173C5.44322 10.7699 5.49998 10.6278 5.6025 10.5218L7.125 9L5.6025 7.47825C5.49998 7.37221 5.44322 7.23015 5.44443 7.08266C5.44564 6.93517 5.50473 6.79406 5.60898 6.68972C5.71322 6.58538 5.85428 6.52616 6.00176 6.5248C6.14925 6.52345 6.29136 6.58008 6.3975 6.6825Z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :md="20">
          <div class="top-navbar-right-menu">
            <ul class="logout-dropdown">
              <li class="logout-list-menu hamburger">
                <div
                  class="workspace-wrapper"
                  v-if="
                    hasTopBarItem('workspaces') ||
                    (!hasTopBarItem('workspaces') && userWorkspaceList?.length != 1)
                  "
                >
                  <div class="workspace-wrapper" v-loading="loading" v-if="!getIsMobile">
                    <el-col v-if="!isExist">
                      <template v-if="!getIsMobile">
                        <el-select
                          class="!bg-card-color rounded-md"
                          v-model="currentWorkspaceId"
                          filterable
                          placeholder="Select Workspace"
                          @change="onWorkspaceChange"
                          :disabled="selectLoad"
                          @clear="onWorkspaceClear"
                          size="mini"
                        >
                          <el-option
                            disabled
                            value=""
                            :label="selectLoad ? 'Loading...' : 'Select Workspace'"
                          />
                          <el-option
                            v-for="(company, index) in userWorkspaceList"
                            :key="index + '_workspace'"
                            :label="company.company_id.name"
                            :value="company.company_id._id"
                          />
                        </el-select>
                      </template>
                    </el-col>
                  </div>
                </div>
                <div
                  v-else
                  class="notification-wrapper dropdown-trigger"
                  @click="toggleWorkspaceDropdown"
                >
                  <div class="icon-block">
                    <div class="icon user-image">
                      <img
                        src="@/assets/img/icons/new/nav-workspace-icon.svg"
                        alt=""
                        class="!size-6"
                      />
                    </div>
                  </div>

                  <div v-if="showWorkspaceDropdown" class="custom-dropdown">
                    <div
                      v-for="(company, index) in userWorkspaceList"
                      :key="index + '_workspace'"
                      :label="company.company_id.name"
                      :value="company.company_id._id"
                      class="dropdown-option"
                      :class="{
                        'active-option': currentWorkspaceId === company.company_id._id,
                      }"
                      @click.stop="selectWorkspace(company)"
                    >
                      {{ company.company_id.name }}
                    </div>
                  </div>
                </div>
              </li>
              <li
                v-if="
                  isWorkspaceIsBusiness &&
                  (hasTopBarItem('roles') ||
                    (!hasTopBarItem('roles') && assignedRoles?.length != 1))
                "
                class="logout-list-menu hamburger"
              >
                <div class="workspace-wrapper" v-loading="loading" v-if="!getIsMobile">
                  <el-col v-if="!isExist">
                    <template v-if="!getIsMobile">
                      <el-select
                        class="!bg-card-color rounded-md"
                        v-model="activeRole"
                        @change="changeRole"
                        placeholder="Select Role"
                        clearable
                        size="mini"
                      >
                        <el-option
                          v-for="(item, index) in assignedRoles"
                          :key="index + '_userType'"
                          :label="`${item.role_title} - ${item.userType_name}`"
                          :value="item.userType_id"
                        />
                      </el-select>
                    </template>
                  </el-col>
                </div>
                <div
                  v-else
                  class="notification-wrapper dropdown-trigger"
                  @click="toggleRoleDropdown"
                >
                  <div class="icon-block">
                    <div class="icon user-image">
                      <img
                        src="@/assets/img/icons/new/nav-user-switch.svg"
                        alt=""
                        class="!size-6"
                      />
                    </div>
                  </div>

                  <div v-if="showRoleDropdown" class="custom-dropdown">
                    <div
                      v-for="(item, index) in assignedRoles"
                      :key="index + '_userType'"
                      :value="item.userType_id"
                      class="dropdown-option"
                      :class="{
                        'active-option': activeRole === item.userType_id,
                      }"
                      @click.stop="selectRole(item)"
                    >
                      {{ item.role_title }} - {{ item.userType_name }}
                    </div>
                  </div>
                </div>
              </li>
              <li
                class="logout-list-menu hamburger"
                v-if="isWorkspaceIsBusiness && globalFilterExists"
              >
                <div class="workspace-wrapper" v-loading="loading" v-if="!getIsMobile">
                  <el-col v-if="globalFilterExists">
                    <template v-if="!getIsMobile">
                      <el-select
                        class="!bg-card-color rounded-md"
                        v-model="globalFilter"
                        :disabled="globalFilterLoading"
                        filterable
                        clearable
                        @change="loadMoreEntityData"
                        :placeholder="
                          globalFilterEntity && globalFilterEntity.name
                            ? 'Select ' + globalFilterEntity.name
                            : 'Select'
                        "
                        size="mini"
                      >
                        <el-option
                          v-for="(data, i) in allGlobalFilterEntityData || []"
                          :key="'entity_' + i + '_' + data._id"
                          :label="getEntityDataLabel(globalFilterEntity, data, i)"
                          :value="data._id"
                        />
                        <el-option
                          v-if="!isSearching && globalFilterHasMoreData"
                          label="Load more..."
                          value="LOADMORE"
                        />
                      </el-select>
                    </template>
                  </el-col>
                </div>
                <div
                  v-else
                  class="notification-wrapper dropdown-trigger"
                  @click="toggleGlobalFilterDropdown"
                >
                  <div class="icon-block">
                    <div class="icon user-image">
                      <img
                        src="@/assets/img/icons/new/nav-filter-icon.svg"
                        alt=""
                        class="!size-6"
                      />
                    </div>
                  </div>

                  <div v-if="showGlobalFilterDropdown" class="custom-dropdown">
                    <div
                      v-for="(data, i) in allGlobalFilterEntityData || []"
                      :key="'entity_' + i + '_' + data._id"
                      :label="getEntityDataLabel(globalFilterEntity, data, i)"
                      :value="data._id"
                      class="dropdown-option"
                      :class="{
                        'active-option': globalFilter === data._id,
                      }"
                      @click.stop="selectGlobalFilter(data, i)"
                    >
                      {{ getEntityDataLabel(globalFilterEntity, data, i) }}
                    </div>
                    <div
                      v-if="!isSearching && globalFilterHasMoreData"
                      class="dropdown-option"
                      @click.stop="selectGlobalFilter({ _id: 'LOADMORE' })"
                    >
                      Load more...
                    </div>
                  </div>
                </div>
              </li>
              <li class="logout-list-menu hamburger">
                <div class="workspace-wrapper" v-loading="loading" v-if="!getIsMobile">
                  <el-button
                    v-for="(action, index) in showActions"
                    :key="index"
                    @click="onAction(action)"
                    class="!text-white !border-brand-500 !px-3 !py-1 text-[11px] !h-7 !min-h-0"
                    :style="{
                      backgroundColor: action.button_color || '#409EFF',
                      color: action.text_color || '#ffffff',
                    }"
                  >
                    {{ action.action_button_label }}
                  </el-button>
                </div>
              </li>
              <li v-if="this.planDetails.diff && hasTopBarItem('chats')" class="hamburger !mr-2">
                <div
                  v-if="!getIsMobile"
                  class="notification-wrapper !border border-transparent hover:!border-black-900 !px-1 !py-[1px] !rounded-sm transition-all duration-300 ease-in-out"
                  @click="toggleChatPopup"
                >
                  <div class="number-on-bell chat" v-if="getChatCountUnOpened > 0">
                    {{ getChatCountUnOpened }}
                  </div>
                  <div class="icon-block">
                    <div class="icon user-image">
                      <el-tooltip content="Chat">
                        <i class="el-icon-message !text-xl text-black-900"></i>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div
                  class="notification-popup"
                  v-if="isChatPopupShow && getChats && getChats.length"
                  v-click-outside="hideChatPopup"
                >
                  <ul
                    class="list-group list-group-flush bg-card-color"
                    v-if="getChats && getChats.length"
                  >
                    <li class="notifications-top-row">
                      <span>Chats({{ getChatsUnReadCnt }})</span>
                      <a @click="markAsReadChats">Mark all as read</a>
                    </li>
                    <li
                      class="list-group-item notifcation-item"
                      v-for="(item, index) in getChats"
                      :key="index + '_chart'"
                      @click="goToChats(item._id, true)"
                    >
                      <div class="item-avatar">
                        {{ item | getUserNameAvatar }}
                        <div class="unread" v-if="!item.is_read"></div>
                      </div>
                      <div class="item-body flex flex-col items-start">
                        <p class="mb-0 text-black-950">
                          <span class="name">{{ item | getUserFullName }}</span>
                          <span class="commented-on">commented on</span>
                          <span class="doc-name">{{ item.title }}</span>
                          {{ item.text | truncate(20, '...') }}
                        </p>
                        <span class="date-time pl-0">
                          {{ item.created_at | getFormattedDateTypeThree }}
                        </span>
                      </div>
                    </li>
                  </ul>
                  <div class="notifications-bottom-row">
                    <a @click="viewAllChats">View all messages</a>
                  </div>
                </div>
              </li>
              <li
                v-if="this.planDetails.diff && hasTopBarItem('esigns_notifications')"
                class="hamburger !mr-2"
              >
                <div
                  v-if="!getIsMobile"
                  class="notification-wrapper !border border-transparent hover:!border-black-900 !px-1 !py-[1px] !rounded-sm transition-all duration-300 ease-in-out"
                  @click="toggleNotificationPopup"
                >
                  <div class="number-on-bell" v-if="getNotificationCountUnOpened > 0">
                    {{ getNotificationCountUnOpened }}
                  </div>
                  <div class="icon-block">
                    <div class="icon user-image">
                      <el-tooltip content="Notifications">
                        <i class="el-icon-bell !text-xl text-black-900"></i>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div
                  class="notification-popup"
                  v-if="isNotificationPopupShow && getNotifications && getNotifications.length"
                  v-click-outside="hideNotificationPopup"
                >
                  <ul
                    class="list-group list-group-flush bg-card-color"
                    v-if="getNotifications && getNotifications.length"
                  >
                    <li class="notifications-top-row !border-b">
                      <span>Notifications({{ getNotificationsUnReadCnt }})</span>
                      <a @click="markAsReadActivities">Mark all as read</a>
                    </li>
                    <li
                      class="list-group-item notifcation-item"
                      v-for="(item, index) in getNotifications"
                      :key="index + '_notification'"
                      @click="goToDocView(item)"
                    >
                      <div>
                        <div class="item-avatar" v-if="item.user_id">
                          {{ item.user_id | getUserNameAvatar }}
                          <div class="unread" v-if="!unmark(item)"></div>
                        </div>
                        <div class="item-avatar" v-if="item.contact_id">
                          {{ item.contact_id | getUserNameAvatar }}
                          <div class="unread" v-if="!unmark(item)"></div>
                        </div>
                      </div>
                      <div class="item-body flex flex-col items-start">
                        <p class="mb-0 text-black-950">
                          <span class="name">{{ item.user_id | getUserFullName }}</span>
                          {{ item.description }}

                          <span class="doc-name" v-if="item.employee_document_id">
                            {{ item.employee_document_id.name }}
                          </span>
                          <span class="doc-name" v-else>&nbsp;</span>
                        </p>
                        <span class="date-time font-normal pl-0">
                          {{ item.created_at | getFormattedDateTypeThree }}
                        </span>
                      </div>
                    </li>
                  </ul>
                  <div class="notifications-bottom-row">
                    <a @click="viewAllNotifications">View all notifications</a>
                  </div>
                </div>
              </li>
              <li
                class="hamburger !mr-2"
                v-if="
                  this.planDetails.diff &&
                  isWorkspaceIsBusiness &&
                  hasTopBarItem('kodefast_notifications')
                "
              >
                <div
                  class="notification-wrapper !border border-transparent hover:!border-black-900 !px-1 !py-[1px] !rounded-sm transition-all duration-300 ease-in-out"
                  @click="toggleAppNotificationPopup"
                >
                  <div v-if="totalUnreadNotificationsCount > 0" class="badge">
                    {{ totalUnreadNotificationsCount }}
                  </div>
                  <div class="icon-block">
                    <el-tooltip content="Entity Notifications">
                      <i class="el-icon-chat-round !text-xl text-black-900"></i>
                    </el-tooltip>
                  </div>
                </div>

                <div
                  :class="[
                    'notification-popup',
                    getIsMobile ? 'mobile-column' : 'notification-popup2',
                  ]"
                  v-if="isAppNotificationPopupShow"
                  v-click-outside="hideAppNotificationPopup"
                >
                  <div
                    class="list-group list-group-flush bg-card-color"
                    v-loading="appNotificationsLoading"
                    element-loading-text="Fetching Logs"
                  >
                    <div
                      v-loading="appNotificationsLoading"
                      element-loading-text="Fetching Logs"
                      :class="[
                        'notifications-top-row first-row-select',
                        { 'mobile-column': getIsMobile },
                      ]"
                    >
                      <span>
                        Notifications({{ unreadNotificationsCount || 0 }}){{
                          allNotificationsCount
                        }}
                      </span>
                      <div>
                        <a @click="markAppNotificationsAsReadChats">Mark all as read</a>
                        <el-tooltip
                          :content="isUnreadOnly == 'ALL' ? 'show unread only' : 'show all'"
                          placement="top"
                        >
                          <el-switch
                            v-model="isUnreadOnly"
                            active-color="var(--brand-500)"
                            inactive-color="var(--black-200)"
                            active-value="UNREAD"
                            inactive-value="ALL"
                            :class="{ 'mobile-switch': getIsMobile }"
                            @change="fetchAppNotifications()"
                          ></el-switch>
                        </el-tooltip>
                      </div>
                    </div>
                    <div class="notifications-top-row !border-b">
                      <div class="flex items-center w-full">
                        <select
                          size="mini"
                          class="form-select form-select-sm"
                          v-model="selectedNotificationType"
                          @change="fetchAppNotifications"
                          style="margin-right: 1%"
                        >
                          <option v-for="e in appNotificationTypes" :key="e.value" :value="e.value">
                            {{ e.name }}
                          </option>
                        </select>

                        <el-input
                          size="mini"
                          placeholder="Search"
                          v-model="notification_search_string"
                          clearable
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <el-scrollbar
                    :style="{
                      maxHeight: getIsMobile ? '300px' : '450px',
                      marginRight: getIsMobile ? '40px' : '0px',
                      overflowY: 'auto',
                    }"
                    :class="{ scrollbar: getIsMobile }"
                  >
                    <ul class="list-group list-group-flush bg-card-color">
                      <div v-loading="appNotificationsLoading" element-loading-text="Fetching Logs">
                        <li
                          :class="[getIsMobile ? '' : 'list-group-item notifcation-item']"
                          v-for="(item, index) in allAppNotifications"
                          :key="index + '_notification'"
                          @click="handleNotificationClick(item)"
                        >
                          <div :class="[getIsMobile ? '' : 'item-avatar']">
                            <span v-if="!getIsMobile">
                              {{ getNotificationTypeAvatar(item.type) }}
                            </span>
                            <div class="unread" v-if="!item.is_read"></div>
                          </div>
                          <div class="item-body">
                            <p class="mb-0 text-black-950 flex flex-col items-start">
                              <span v-if="getIsMobile" class="dot"></span>
                              <span v-html="getAppNotificationDescription(item)"></span>

                              <span class="date-time font-normal pl-0">
                                {{ item.created_at | getFormattedDateTypeThree }}
                              </span>
                            </p>
                          </div>
                        </li>
                        <li
                          class="load-more-element"
                          @click="loadMoreLogs()"
                          v-if="allNotificationsCount > totalPageLogs"
                          v-loading="LoadMoreLoading"
                        >
                          <div class="load-more">
                            <a>Load More...</a>
                          </div>
                        </li>
                        <li
                          v-if="allAppNotifications && !allAppNotifications.length"
                          class="list-group-item notifcation-item"
                        >
                          <div class="item-avatar">ND</div>
                          <div class="item-body">
                            <p class="mb-0 text-black-950">
                              <span>You have no notifications to show</span>
                            </p>
                            <span class="date-time text-dark fw-medium pl-0 opacity-80">-</span>
                          </div>
                        </li>
                      </div>
                    </ul>
                  </el-scrollbar>
                </div>
              </li>
              <li class="!ml-2">
                <el-dropdown>
                  <el-button style="font-family: var(--font-family)">
                    <div class="icon-block">
                      <div class="icon user-image profile-image">
                        <img
                          v-if="
                            getAuthenticatedUser &&
                            getAuthenticatedUser.avatar &&
                            getAuthenticatedUser.avatar.length > 20
                          "
                          :src="getAuthenticatedUser.avatar"
                          alt="user-image"
                          class="!size-7"
                        />

                        <img
                          v-else
                          src="@/assets/img/avatar.svg"
                          alt="user-image"
                          class="!size-7"
                        />
                      </div>
                      <!-- DESKTOP VIEW -->
                      <div class="flex items-ceter !gap-4" v-if="!getIsMobile">
                        <div>
                          <div
                            class="icon-text text-left text-black-900 !font-normal !text-sm"
                            v-if="!getIsMobile"
                          >
                            {{ getAuthenticatedUser | getUserFullName }}
                          </div>
                          <div
                            class="icon-text text-left text-black-900 !font-normal !text-sm"
                            v-else
                          >
                            {{ getAuthenticatedUser | getUserFullNameShortened }}
                          </div>
                          <template v-if="isWorkspaceIsBusiness">
                            <p
                              class="first-letter:uppercase first-letter:tracking-wide lowercase text-left text-black-900 !font-normal !text-xs"
                            >
                              <span v-if="getAuthenticatedUser?.activeRole?.userType_id">
                                {{ getAuthenticatedUser.activeRole.userType_name }}
                              </span>
                              <span v-else>{{ getUserType.name }}</span>
                            </p>
                          </template>
                          <template v-else>
                            <p
                              class="first-letter:uppercase first-letter:tracking-wide lowercase text-left text-black-900 font-normal !text-xs"
                            >
                              <span>INDIVIDUAL</span>
                            </p>
                          </template>
                        </div>
                        <i class="el-icon-caret-bottom !text-base text-black-900"></i>
                      </div>
                      <!-- MOBILE VIEW -->
                      <div class="icon-text" v-else @click="showUserNameModal = true">
                        <div class="circle-name">
                          {{ getAuthenticatedUser | getUserFullNameShortened }}
                        </div>
                      </div>
                    </div>
                  </el-button>
                  <el-dropdown-menu v-if="!getIsMobile" slot="dropdown">
                    <router-link to="/profile">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/profile.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Profile
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/profilesettings">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/settings.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Settings
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      v-if="isWorkspaceIsBusiness && this.isOwner()"
                      :to="`/${currentWorkspaceId}/configuration`"
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/integration.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Integrations
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      v-if="isWorkspaceIsBusiness && checkPermissionsCategory('companyUsers')"
                      to="/company/users"
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/company-user.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Company Users
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        checkPermissionByPermissionName('viewFormTemplates')
                      "
                      to="/template"
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/form-template.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Form Template
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        checkPermissionByPermissionName('viewEmailTemplate')
                      "
                      to="/email-template"
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/notification-template.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Notification Templates
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        checkPermissionByPermissionName('viewEntities')
                      "
                      to="/entity"
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/entities.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Entities
                      </el-dropdown-item>
                    </router-link>

                    <router-link
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        // getAccessToEachFeature('include_entities_in_plan') &&
                        checkPermissionByPermissionName('viewEntities')
                      "
                      to="/entity/automation"
                    >
                      <el-dropdown-item>
                        <i class="el-icon-setting"></i>
                        Entity Automation
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        checkPermissionByPermissionName('viewEntities')
                      "
                      to="/entity-views"
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/entities-view.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Entities Views
                      </el-dropdown-item>
                    </router-link>
                    <router-link to="/forums">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/discussion-forum.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Discussion Forums
                        <el-badge
                          v-if="unreadForumsCount"
                          :value="unreadForumsCount"
                          type="success"
                        ></el-badge>
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        checkPermissionByPermissionName('viewGlobalVaribales')
                      "
                      to="/global-variables"
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/global-variables.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Global Variables
                      </el-dropdown-item>
                    </router-link>

                    <router-link
                      to="/company-entity-groups"
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        checkPermissionByPermissionName('viewMenuGroups')
                      "
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/groups-1.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Groups
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      to="/formBuilders"
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        checkPermissionByPermissionName('viewFormBuilders')
                      "
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/form-builder.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Form Builder
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      to="/custom/dashboard-list"
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        checkPermissionByPermissionName('viewDashboards')
                      "
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/custom-dashboard.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Custom Dashboard
                      </el-dropdown-item>
                    </router-link>
                    <router-link
                      to="/apps"
                      v-if="
                        this.isWorkspaceIsBusiness &&
                        checkPermissionsCategory('marketPlace') &&
                        checkPermissionByPermissionName('viewMarketplace') &&
                        getCompanyDetails &&
                        !getCompanyDetails.is_admin_clone &&
                        !getCompanyDetails.is_cloned
                      "
                    >
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/Marketplace.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Market Place
                      </el-dropdown-item>
                    </router-link>
                    <router-link to="/developer/portal" v-if="this.isWorkspaceIsBusiness">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/integration-menu.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Integrations Menu
                      </el-dropdown-item>
                    </router-link>
                    <a @click="logout()">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/log-out.svg"
                          alt="menu"
                          class="svg"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Logout
                      </el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                  <el-dropdown-menu slot="dropdown" class="mob" v-else>
                    <div class="dropdown-profile-block">
                      <div class="circle-name">
                        {{ getAuthenticatedUser | getUserFullNameShortened }}
                      </div>

                      <div class="profile-details">
                        <div class="profile-full-name">
                          {{ getAuthenticatedUser | getUserFullName }}
                        </div>
                        <div class="profile-role">
                          {{ assignedRoles[0]?.role_title }} -
                          {{ assignedRoles[0]?.userType_name }}
                        </div>
                      </div>

                      <div class="top-icons">
                        <el-tooltip content="Logout" placement="top">
                          <div class="logout-icon" @click="logout">
                            <i class="el-icon-switch-button"></i>
                          </div>
                        </el-tooltip>
                      </div>
                    </div>

                    <hr class="dropdown-divider" />

                    <li class="logout-list-menu select-pair-wrapper">
                      <div class="select-group-horizontal">
                        <i
                          class="fa fa-building select-icon"
                          aria-hidden="true"
                          title="Workspace"
                        ></i>
                        <el-select
                          v-model="currentWorkspaceId"
                          filterable
                          placeholder="Select Workspace"
                          @change="onWorkspaceChange"
                          :disabled="selectLoad"
                          @clear="onWorkspaceClear"
                          size="mini"
                          class="select-field"
                        >
                          <el-option
                            disabled
                            value=""
                            :label="selectLoad ? 'Loading...' : 'Select Workspace'"
                          />
                          <el-option
                            v-for="(company, index) in userWorkspaceList"
                            :key="index + '_workspace'"
                            :label="company.company_id.name"
                            :value="company.company_id._id"
                          />
                        </el-select>
                      </div>

                      <div class="select-group-horizontal" v-if="isWorkspaceIsBusiness">
                        <i class="fa fa-users select-icon" aria-hidden="true" title="User Role"></i>
                        <el-select
                          v-model="activeRole"
                          @change="changeRole"
                          placeholder="Select Role"
                          clearable
                          size="mini"
                          class="select-field"
                        >
                          <el-option
                            v-for="(item, index) in assignedRoles"
                            :key="index + '_userType'"
                            :label="`${item.role_title} - ${item.userType_name}`"
                            :value="item.userType_id"
                          />
                        </el-select>
                      </div>
                    </li>

                    <div class="dropdown-header">User info</div>

                    <router-link to="/profile">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/profile.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />

                        Profile
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/profilesettings">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/settings.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Settings
                      </el-dropdown-item>
                    </router-link>
                    <div class="dropdown-header">Teams</div>
                    <router-link to="/company/users">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/company-user.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Company Users
                      </el-dropdown-item>
                    </router-link>

                    <div class="dropdown-header">Integrations & Collaborations</div>

                    <router-link :to="`/${currentWorkspaceId}/configuration`">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/integration.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Integrations
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/developer/portal">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/integration-menu.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Integrations Menu
                      </el-dropdown-item>
                    </router-link>

                    <div class="dropdown-header">Builder Components</div>

                    <router-link to="/global-variables">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/global-variables.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Global Variables
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/company-entity-groups">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/groups-1.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Groups
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/template">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/form-template.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Form Template
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/entity">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/entities.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Entities
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/entity-views">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/entities-view.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Entities Views
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/custom/dashboard-list">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/custom-dashboard.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Custom Dashboard
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/formBuilders">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/form-builder.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Form Builder
                      </el-dropdown-item>
                    </router-link>

                    <div class="dropdown-header">App store</div>

                    <router-link to="/apps">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/market-place.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Market Place
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/email-template">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/notification-template.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />

                        Notification Templates
                      </el-dropdown-item>
                    </router-link>

                    <router-link to="/forums">
                      <el-dropdown-item class="flex items-center !gap-2">
                        <img
                          src="@/assets/img/sideMenu/inactive_icons/discussion-forum.svg"
                          alt="menu"
                          class="svg icon icon_mobile"
                          style="height: 12px; width: 14px; margin-right: 2px"
                        />
                        Discussion Forums
                      </el-dropdown-item>
                    </router-link>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>

    <dialog-component
      id="settingsDialog"
      class="all-notifications-dialog"
      :width="getIsMobile ? '100%' : '60%'"
      :visible="isViewAllNotificationsPopupShow"
      :title="'All Notifications'"
      @before-close="handleCloseAllNotificationsPopup"
      :modalAppendToBody="false"
      :isShowFooter="false"
      ref="viewAllNotificationsPopup"
    >
      <ViewAllNotifications v-if="isViewAllNotificationsPopupShow" />
    </dialog-component>
    <dialog-component
      class="all-notifications-dialog"
      :width="getIsMobile ? '100%' : '60%'"
      :visible.sync="isViewAllAppNotificationsPopupShow"
      :title="'All Notifications'"
      :show-close="true"
      :modalAppendToBody="false"
      ref="viewAllNotificationsPopup"
    >
      <viewAllAppNotifications v-if="isViewAllAppNotificationsPopupShow" />
    </dialog-component>

    <div class="vue-modal">
      <dialog-component
        class="all-chats-dialog"
        :width="getIsMobile ? '100%' : '60%'"
        :visible="isViewAllChatsPopupShow"
        :title="'All Chats'"
        @before-close="isViewAllChatsPopupShow = false"
        :modalAppendToBody="false"
        ref="viewAllChatsPopup"
        :isShowFooter="false"
      >
        <ViewAllChats></ViewAllChats>
      </dialog-component>
    </div>
    <div></div>
  </section>
</template>

<script>
  import { bus } from '../main';
  import { mapGetters, mapActions } from 'vuex';
  import axios from '@/config/axios';
  import ViewAllNotifications from '../components/notifications/ViewAllNotifications';
  import ViewAllChats from '../components/notifications/ViewAllChats';
  import PermissionsHelper from '@/mixins/permissionsHelper';
  import Swal from 'sweetalert2';
  import appConfig from '@/config/app';
  import moment from 'moment';
  import authHelper from '@/mixins/authHelper';
  import { postAPICall } from '@/helpers/httpHelper';
  import { fetchUserTypes } from '@/repo/commonApiRepo';
  import AccessManagement from '@/mixins/AccessManagement';
  import templateBuilderHelper from '../mixins/templateBuilderHelper';
  export default {
    name: 'TopBarDefault',
    components: {
      ViewAllNotifications,
      ViewAllChats,
    },

    mixins: [PermissionsHelper, authHelper, AccessManagement, templateBuilderHelper],
    data() {
      return {
        showMobileProfileMenu: false,
        lastSelectedWorkspaceId: null,
        showWorkspaceDropdown: false,
        showRoleDropdown: false,
        showGlobalFilterDropdown: false,
        loadingText: 'Gathering your workspace resources, please wait...',
        events: [
          'keyup',
          'keypress',
          'keydown',
          'click',
          'contextmenu',
          'dbclick',
          'mousedown',
          'mouseenter',
          'mouseleave',
          'mousemove',
          'mouseout',
          'mouseover',
          'mouseup',
          'error',
          'loadstart',
          'touchcancel',
          'touchend',
          'touchmove',
          'touchstart',
          'select',
          'unload',
          'scroll',
          'resize',
          'load',
          'beforeunload',
          'abort',
          'wheel',
        ],
        res: [],
        title: '',
        isOpen: false,
        isCollapse: '',
        routerValue: '',
        offCanvas: '',
        documentLogs: [],
        openProfile: false,
        isNotificationPopupShow: false,
        isAppNotificationPopupShow: false,
        selectedNotificationType: 'ALL',
        appNotificationTypes: [
          {
            name: 'All',
            value: 'ALL',
          },
          {
            name: 'Entity',
            value: 'ENTITY',
          },
          {
            name: 'Form Builder',
            value: 'FORM_BUILDER',
          },
          {
            name: 'Email',
            value: 'NOTIFICATION',
          },
          {
            name: 'Others',
            value: 'OTHERS',
          },
        ],
        isViewAllNotificationsPopupShow: false,
        isUnreadOnly: '',
        isViewAllAppNotificationsPopupShow: false,
        notification_search_string: '',
        appNotificationsLoading: false,
        allAppNotifications: null,
        isChatPopupShow: false,
        unreadNotificationsCount: null,
        totalNotificationsCount: null,
        allNotificationsCount: null,
        totalUnreadNotificationsCount: null,
        isViewAllChatsPopupShow: false,
        LoadMoreLoading: false,
        totalPageLogs: 0,
        isExist: false,
        selectLoad: false,
        permissionsList: [],
        loading: false,
        isLoading: false,
        fullPage: true,
        canCancel: true,
        useSlot: false,
        loader: 'spinner',
        color: '#F754A2',
        bgColor: '#b0aeae',
        height: 64,
        width: 64,
        timeout: 15000, //ms
        opacity: 0.7,
        assignedRoles: [],
        baseURL: window.location.origin + '/signin',
        serverBaseURL: appConfig.AUTHFAST_BASE_URL,
        planDetails: {},
        loginPageColor: '#1B487E',
        isHorMenu: true,
        globalFilter: '',
        appSetting: {},
        logo: null,
        notificationsPageSize: 10,
        notificationsPage: 1,
        userTypes: [],
        botId: '',
        token: '',
        unreadForumsCount: 0,
      };
    },
    computed: {
      ...mapGetters('userStatus', ['getNotificationCountUnOpened', 'getChatCountUnOpened']),
      ...mapGetters('navigationOpen', ['getIsMobile', 'getIsOpen']),
      ...mapGetters('auth', [
        'getAuthenticatedUser',
        'getActiveWorkspace',
        'getAuthenticationStatus',
        'getWorkspaceList',
        'getUserType',
        'getSwitchWorkspaceError',
        'getPermissionList',
        'getPermissions',
        'getGlobalFiltervalue',
        'getAuthenticationDetails',
        'getUserTypeList',
        'getUserTypeEmailsErrors',
        'getUserTypeEmails',
        'getDefaultDateFormat',
      ]),
      ...mapGetters('dashboard', [
        'getNotifications',
        'getChats',
        'getNotificationsUnReadCnt',
        'getChatsUnReadCnt',
      ]),
      ...mapGetters('company', [
        'getCompanyDetails',
        'getUpdateCompany',
        'getCompanyLogo',
        'getSingleCompanyLogo',
        'getContactLoginSlug',
      ]),
      ...mapGetters('paymentGateway', ['getPaymentsHistory', 'getPlansFeatures']),
      ...mapGetters('menuManagementV2', ['getMenu']),
      ...mapGetters('appNotifications', [
        'getAllAppNotifications',
        'getAppNotificationErrors',
        'getMarkAllAsReadStatus',
      ]),
      ...mapGetters('UserIntegrations', ['getIntegrationsList']),
      showActions() {
        return (this.getCompanyDetails?.action_buttons || []).filter((a) => a.is_active);
      },
    },
    async mounted() {
      this.loading = true;
      this.appSetting = appConfig;
      let [, unreadForums] = await Promise.all([
        this.getCompanyConfigurationsList(),
        postAPICall('GET', '/forums/new-threads'),
      ]);
      this.$nextTick(() => {
        setTimeout(() => this.replaceSvgImages(), 100); // 👈 Call method after DOM is ready
      });
      if (unreadForums.data) {
        this.unreadForumsCount = unreadForums.data;
      }
      document.addEventListener('click', this.handleClickOutside);
      try {
        if (this.getAuthenticatedUser && this.getAuthenticatedUser.contact_type) {
          await this.handleLogoutInfo();
        } else {
          await this.getNecessaryInfo();
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    watch: {
      $route({ meta }) {
        this.title = meta.title || 'Dashboard';
      },
      permissionsList: async function () {
        if (this.permissionsList) {
          const permissionsData = await Promise.all(
            this.permissionsList.map(async (cat) => {
              const permissions = await Promise.all(cat.permissions.map((item) => item.slug));
              return permissions;
            })
          );
          const permissionSet = permissionsData.flat();
          await this.$store.dispatch('auth/CompanyPermissionSet', permissionSet);
        }
      },
      getPaymentsHistory: async function () {
        this.setPaymentsHistory();
      },
      getSingleCompanyLogo: async function () {
        if (this.getSingleCompanyLogo) {
          this.logo = `${appConfig.S3_BUCKET_URL}/${this.getSingleCompanyLogo}`;
        }
      },
      notification_search_string: {
        handler: function () {
          this.fetchAppNotifications();
        },
        deep: true,
      },
    },
    methods: {
      onAction(action) {
        this.checkNavigationAction(action);
      },

      hasTopBarItem(item) {
        const items = this.getCompanyDetails?.company_settings?.topbar_items;
        if (!items) {
          return true;
        }
        return items.includes(item);
      },
      handleOutsideClick(event) {
        if (!this.getIsMobile) return;
        const wsRef = this.$refs.workspaceDropdown;
        const roleRef = this.$refs.roleDropdown;
        const gfRef = this.$refs.globalFilterDropdown;
        const clickedOutsideWorkspace = wsRef && !wsRef.contains(event.target);
        const clickedOutsideRole = roleRef && !roleRef.contains(event.target);
        const clickedOutsideGlobalFilter = gfRef && !gfRef.contains(event.target);
        if (this.showWorkspaceDropdown && clickedOutsideWorkspace) {
          this.showWorkspaceDropdown = false;
        }
        if (this.showRoleDropdown && clickedOutsideRole) {
          this.showRoleDropdown = false;
        }
        if (this.showGlobalFilterDropdown && clickedOutsideGlobalFilter) {
          this.showGlobalFilterDropdown = false;
          this.isAppNotificationPopupShow = false;
        }
      },
      toggleWorkspaceDropdown() {
        this.showWorkspaceDropdown = !this.showWorkspaceDropdown;
        this.showRoleDropdown = false;
        this.showGlobalFilterDropdown = false;
        this.isAppNotificationPopupShow = false;
      },
      selectWorkspace(company) {
        const val = company.company_id._id;
        this.currentWorkspaceId = val;
        this.onWorkspaceChange(val);
        this.showWorkspaceDropdown = false;
      },
      toggleRoleDropdown() {
        this.showRoleDropdown = !this.showRoleDropdown;
        this.showGlobalFilterDropdown = false;
        this.showWorkspaceDropdown = false;
        this.isAppNotificationPopupShow = false;
      },
      selectRole(role) {
        const val = role.userType_id;
        this.activeRole = val;
        this.changeRole();
        this.showRoleDropdown = false;
      },
      toggleGlobalFilterDropdown() {
        this.showGlobalFilterDropdown = !this.showGlobalFilterDropdown;
        this.showRoleDropdown = false;
        this.isAppNotificationPopupShow = false;
        this.showWorkspaceDropdown = false;
      },
      selectGlobalFilter(data) {
        const val = data._id;
        if (val === 'LOADMORE') {
          this.loadMoreEntityData('LOADMORE');
        } else {
          this.globalFilter = val;
          this.loadMoreEntityData(val);
        }
        this.showGlobalFilterDropdown = false;
      },
      async fetchSubscriptionInfo() {
        let response = await axios.get('/getSubscriptionData');
        this.$store.commit('paymentGateway/setSubscriptionPlanDetails', response.data.data, {
          root: true,
        });
      },
      onWorkspaceClear() {
        this.$nextTick(() => {
          this.currentWorkspaceId = this.lastSelectedWorkspaceId;
        });
      },
      onWorkspaceChange(val) {
        if (!val) return;
        this.currentWorkspaceId = val;
        this.ChangeAccount();
      },
      async getBotAccounts() {
        this.loading = true;
        try {
          let response = await postAPICall('GET', '/bot/get-Bot');

          if (response && response.success && response.data?.chatBotDetails) {
            const botAccounts = response.data?.chatBotDetails || '';

            const botIdRegex = /botId: '(.*?)'/;
            const tokenRegex = /token: '(.*?)'/;

            const botIdMatch = botAccounts.match(botIdRegex);
            const tokenMatch = botAccounts.match(tokenRegex);

            if (botIdMatch && tokenMatch) {
              this.botId = botIdMatch[1];
              this.token = tokenMatch[1];
              localStorage.setItem('botId', this.botId);
              localStorage.setItem('token', this.token);
            }
          }
        } catch (error) {
          console.error('Chat bot', error);
        } finally {
          this.loading = false;
        }
      },
      async getNecessaryInfo() {
        this.loading = true;
        this.selectLoad = true;
        this.title = this.$route.meta.title || 'Dashboard';
        let promises = [
          this.getPermissionsList(),
          this.fetchUserData(),
          this.getStyleForHorMenu(),
          this.fetchRolesList(),
          this.getSubscriptionHistory(),
          this.fetchSubscriptionInfo(),
        ];
        if (this.isWorkspaceIsBusiness) {
          if (!this.isIndividualWorkspace) {
            promises.push(this.getCompanyInfo(false));
          }
        }
        await Promise.all(promises);
        this.fetchNotifications();
        this.fetchAppNotifications();
        this.fetchChats();
        this.setActiveRole();
        this.getCompanyUserTypeList();
        this.fetchUserStatus();
        this.getCompanyConfigurationsList();
        if (!Object.keys(this.planDetails)?.length) {
          this.setPaymentsHistory();
        }
        bus.$on('workspaceList', (data) => {
          this.userWorkspaceList = data;
        });
        if (this.getSingleCompanyLogo) {
          this.logo = `${appConfig.S3_BUCKET_URL}/${this.getSingleCompanyLogo}`;
        }
        if (!this.brandingInfo?.is_menu_open) {
          this.$store.commit('navigationOpen/setIsOpen', false, {
            root: true,
          });
        }

        this.loading = false;
      },
      async getCompanyConfigurationsList() {
        this.loading = true;
        await this.$store.dispatch('UserIntegrations/fetchIntegrationsList');
        this.loading = false;
      },
      getEntityDataLabel(selectedEntity, item, i) {
        let name = 'data ' + i;
        if (selectedEntity && selectedEntity.primaryFields) {
          let primaryField = selectedEntity.primaryFields[0];
          let key = primaryField && primaryField['key'] ? primaryField['key'] : null;
          if (key) {
            name =
              item.entityData &&
              primaryField.template_id &&
              item.entityData[primaryField.template_id]
                ? item.entityData[primaryField.template_id][key + '/name']
                  ? item.entityData[primaryField.template_id][key + '/name']
                  : item.entityData[primaryField.template_id][key]
                    ? primaryField.input_type == 'DATE'
                      ? moment(item.entityData[primaryField.template_id][key]).format(
                          this.getDefaultDateFormat
                        )
                      : primaryField.input_type == 'DATE_TIME'
                        ? moment(
                            item.entityData[primaryField.template_id][primaryField.key]
                          ).format(this.getDefaultDateFormat + ' HH:mm:ss')
                        : item.entityData[primaryField.template_id][key]
                    : 'data' + i
                : 'data' + i;
          }
        }
        return name;
      },
      loadMoreEntityData(value, query) {
        if (value == 'LOADMORE') {
          this.globalFilter = '';
          this.globalFilterPage++;
          this.loadMore = true;
          this.fetchGlobalFilterEntityData();
        } else {
          this.$store.commit('auth/setGlobalFiltervalue', value, {
            root: true,
          });
          this.searchEntityData(query);
        }
      },
      searchEntityData(query) {
        if (query) {
          this.isSearching = true;
          if (query.length > 2) {
            this.globalFilterSearch = query;
            this.page = 1;
            this.fetchGlobalFilterEntityData();
          }
        } else {
          this.isSearching = false;
          this.globalFilterSearch = '';
          this.page = 1;
          this.fetchGlobalFilterEntityData();
        }
      },
      onIdle() {
        let timerInterval;
        Swal.fire({
          title: 'Session Timed Out',
          html: `Your session has been automatically logged out due to inactivity`,
          timer: 4000,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            clearInterval(timerInterval);
            this.logout();
          },
        });
      },
      onRemind(time) {
        let timerInterval;
        Swal.fire({
          title: '',
          html: `Your session will automatically log out after ${time} seconds due to inactivity`,
          timer: 4000,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        });
      },
      async fetchRolesList() {
        if (this.getAuthenticatedUser && this.getAuthenticatedUser.roles) {
          this.assignedRoles = this.getAuthenticatedUser.roles;
        } else {
          this.assignedRoles = [];
        }
      },
      getLabel() {
        return (userType) => {
          if (userType && userType.role) {
            return userType.role.title + ' - ' + userType.name;
          } else {
            return userType.name;
          }
        };
      },

      ...mapActions({
        fetchUserStatus: 'userStatus/fetchUserStatus',
        updateUserStatus: 'userStatus/updateUserStatus',
        fetchNotifications: 'dashboard/fetchNotifications',
        fetchChats: 'dashboard/fetchChats',
        fetchPermissionList: 'auth/getPermissions',
        fetchPermissions: 'auth/updatePermissions',
        fetchAllAppNotifications: 'appNotifications/fetchAllAppNotifications',
      }),
      handleCloseAllNotificationsPopup() {
        this.isViewAllNotificationsPopupShow = false;
      },
      async getPermissionsList() {
        this.loading = true;
        try {
          if (this.getPermissionList) {
            this.permissionsList = this.getPermissionList;
          }
        } catch (err) {
          console.log('getPermissionsList', err);
        }
      },
      async getPermissionsListByCat() {
        try {
          let data = {
            categories: this.getPaymentsHistory.featuresList,
          };
          await this.$store.dispatch('auth/getPermissionsByCat', data);
          if (this.getPermissionList) {
            this.permissionsList = this.getPermissionList;
          }
          this.loading = false;
        } catch (err) {
          console.log('getPermissionsListByCat', err);
        }
      },

      async goToChats(document_id, isChat = false) {
        if (isChat) {
          this.markAsReadChats({
            document_id,
          });
        }
        if (document) {
          if (document.document_status == 'DRAFT') {
            this.$router.push({
              name: 'employee-documents-custom-document-edit',
              params: {
                employee_document_id: document_id,
              },
            });
          } else {
            this.$router.push({
              name: 'employee-documents-custom-document',
              params: {
                employee_document_id: document_id,
              },
              query: {
                tab: 'chat',
              },
            });
          }
        }
      },
      async goToDocView(document) {
        if (document && document.employee_document_id && document.employee_document_id._id) {
          this.markAsReadEachActivities(document._id);
          if (document) {
            if (document.document_status == 'DRAFT') {
              this.$router.push({
                name: 'employee-documents-custom-document-edit',
                params: {
                  employee_document_id: document.employee_document_id._id,
                },
              });
            } else {
              this.$router.push({
                name: 'employee-documents-custom-document',
                params: {
                  employee_document_id: document.employee_document_id._id,
                },
                query: {
                  tab: 'logs',
                },
              });
            }
          }
        } else {
          this.$router.push({
            path: '/templates',
          });
        }
      },
      viewAllNotifications() {
        this.isViewAllNotificationsPopupShow = true;
        this.isNotificationPopupShow = false;
        document.body.className += ' modal-open';
      },
      viewAllAppNotifications() {
        this.isViewAllAppNotificationsPopupShow = true;
        this.isAppNotificationPopupShow = false;
        document.body.className += ' modal-open';
      },
      viewAllChats() {
        this.isViewAllChatsPopupShow = true;
        this.isChatPopupShow = false;
        document.body.className += ' modal-open';
      },
      async toggleNotificationPopup() {
        if (this.getNotifications && !this.getNotifications.length) {
          this.$message.info('You have no notifications yet to display.');
        }
        this.isNotificationPopupShow = !this.isNotificationPopupShow;
        if (this.isNotificationPopupShow) {
          this.updateUserStatus({
            notification_last_open_date: '1',
          });
          this.fetchUserStatus();
        }
      },
      async toggleAppNotificationPopup() {
        this.isAppNotificationPopupShow = !this.isAppNotificationPopupShow;
        this.showGlobalFilterDropdown = false;
        this.showRoleDropdown = false;
        this.showWorkspaceDropdown = false;
        if (this.isAppNotificationPopupShow && !this.allAppNotifications?.length) {
          this.fetchAppNotifications();
        }
      },
      async fetchAppNotifications() {
        this.appNotificationsLoading = true;
        let params = {
          type: this.selectedNotificationType,
        };
        if (this.notification_search_string) {
          params['search_string'] = this.notification_search_string;
        }
        if (this.isUnreadOnly == 'UNREAD') {
          params['is_read'] = false;
        }
        await this.fetchAllAppNotifications(params);
        if (this.getAllAppNotifications) {
          this.allAppNotifications = this.getAllAppNotifications.data;
          this.unreadNotificationsCount = this.getAllAppNotifications.unread_count;
          this.totalNotificationsCount = this.getAllAppNotifications.total_notifications_count;
          this.allNotificationsCount = this.getAllAppNotifications.total_count;
          this.totalUnreadNotificationsCount = this.getAllAppNotifications.total_unread_count;
        }
        this.totalPageLogs = 20;
        this.appNotificationsLoading = false;
      },
      async loadMoreLogs() {
        this.LoadMoreLoading = true;
        let params = {
          type: this.selectedNotificationType,
          skip: this.totalPageLogs,
          limit: 20,
          is_load_more: true,
        };
        if (this.notification_search_string) {
          params['search_string'] = this.notification_search_string;
        }
        if (this.isUnreadOnly == 'UNREAD') {
          params['is_read'] = false;
        }
        await this.fetchAllAppNotifications(params);
        if (this.getAllAppNotifications) {
          this.totalPageLogs = this.totalPageLogs + 20;
          this.allAppNotifications = [
            ...this.allAppNotifications,
            ...this.getAllAppNotifications.data,
          ];
        }
        this.LoadMoreLoading = false;
      },
      async toggleChatPopup() {
        if (this.getChats && !this.getChats.length) {
          this.$message.info('You have no chats yet to display.');
        }
        this.isChatPopupShow = !this.isChatPopupShow;
        if (this.isChatPopupShow) {
          this.updateUserStatus({
            chat_last_open_date: '1',
          });
          this.fetchUserStatus();
        }
      },
      unmark(doc) {
        if (
          doc.sender_email &&
          doc.sender_email.email == this.getAuthenticatedUser.email &&
          doc.sender_email.is_read &&
          doc.sender_email.is_read == true
        ) {
          return doc.sender_email.is_read;
        } else {
          let user = doc.rec_email.find(
            (x) => x.email && x.email == this.getAuthenticatedUser.email && x.is_read
          );
          return user;
        }
      },
      async markAsReadEachActivities(query = {}) {
        try {
          await axios.post('all-documents/mark-as-read-each-activities', {
            query,
          });
          if (this.getNotificationsUnReadCnt > 0) {
            await this.fetchNotifications();
          }
        } catch (err) {
          console.log('markAsReadActivities', err);
        }
      },
      async markAsReadActivities() {
        try {
          await axios.post('all-documents/mark-as-read-activities');
          await this.fetchNotifications();
          if (this.getNotificationsUnReadCnt > 0) {
            await this.fetchNotifications();
          } else {
            this.$message.warning("You don't have any unread Notifications");
          }
          this.isNotificationPopupShow = false; // Close the popup
        } catch (err) {
          console.log('markAsReadActivities', err);
        }
      },
      async markAsReadChats(query = {}) {
        try {
          await axios.post('all-documents/mark-as-read-notes', {
            query,
          });

          if (this.getChatsUnReadCnt > 0) {
            await this.fetchChats();
          } else {
            this.$message.warning("You don't have any unread Chats");
          }
          this.isChatPopupShow = false; // Close the popup
        } catch (err) {
          console.log('markAsReadChats', err);
        }
      },
      async markAppNotificationsAsReadChats() {
        if (this.unreadNotificationsCount) {
          await this.$store.dispatch('appNotifications/markAllAsRead', {
            type: this.selectedNotificationType,
          });
          if (this.getMarkAllAsReadStatus) {
            this.fetchAppNotifications();
          }
        } else {
          this.$message.warning("You don't have any unread Notifications");
        }
      },
      hideNotificationPopup() {
        this.isNotificationPopupShow = false;
      },
      hideAppNotificationPopup() {
        this.isAppNotificationPopupShow = false;
      },
      async handleNotificationClick(item) {
        if (!item.is_read) {
          this.totalUnreadNotificationsCount = this.totalUnreadNotificationsCount - 1;
        }
        let routerPath = '';
        let params = {
          id: item._id,
          data: {
            is_read: true,
          },
        };
        this.$store.dispatch('appNotifications/updateDataById', params);
        this.isAppNotificationPopupShow = false;
        let keyValue = Math.floor(Math.random() * 100000);
        switch (item.type) {
          case 'ENTITY':
            switch (item.when) {
              case 'ADDED':
              case 'UPDATED':
                routerPath = `/entity/view/${item.entity_id._id}?key=${keyValue}&dataId=${item.entity_data_id}&filter=&layout=PROFILE&page=1&pageSize=10`;
                break;
              case 'BULK_UPDATE':
                routerPath = `/entity/${item.entity_id._id}?key=${keyValue}`;
                break;
              default:
                routerPath = '';
            }
            break;
          case 'FORM_BUILDER':
            switch (item.when) {
              case 'FILLED':
              case 'APPROVED':
              case 'REJECTED':
                routerPath = `/fbd/${item.form_builder_id?.code}?key=${keyValue}`;
                break;
              default:
                routerPath = '';
            }
            break;
          case 'NOTIFICATION':
            if (item.mail_sending_type == 'ENTITY') {
              routerPath = `/entity/view/${item.entity_id._id}?key=${keyValue}&dataId=${item.entity_data_id}&filter=&layout=PROFILE&page=1&pageSize=10`;
            } else if (item.mail_sending_type == 'FORM_BUILDER') {
              routerPath = `/fbd/${item.form_builder_id?.code}?key=${keyValue}`;
            }
            break;
          default:
            routerPath = '';
            break;
        }
        item.is_read = true;
        this.$router.push({
          path: routerPath,
        });

        //updateLogToRead and fetch again
        this.fetchAppNotifications();
      },
      getNotificationTypeAvatar(type) {
        let name = '';
        switch (type) {
          case 'ENTITY':
            name = 'EN';
            break;
          case 'FORM_BUILDER':
            name = 'FB';
            break;
          case 'NOTIFICATION':
            name = 'NF';
            break;
          case 'OTHERS':
            name = 'OT';
            break;
          default:
            name = '';
            break;
        }
        return name;
      },
      getAppNotificationDescription(item) {
        let description = '';
        switch (item.type) {
          case 'ENTITY':
            switch (item.when) {
              case 'ADDED':
                description = `A new entity data is <b>added</b> in <b>${item.entity_id?.name}</b>.`;
                break;
              case 'UPDATED':
                description = `An entity data is <b>updated</b> in <b>${item.entity_id?.name}</b>.`;
                break;
              case 'DELETED':
                description = `A entity data is <b>deleted</b> in <b>${item.entity_id?.name}</b>.`;
                break;
              case 'BULK_UPDATE':
                description = `Bulk update was performed in <b>${item.entity_id?.name}</b>.`;
                break;
              default:
                description = 'Action in Entity';
                break;
            }
            break;
          case 'FORM_BUILDER':
            switch (item.when) {
              case 'FILLED':
                description = `A new form data is <b>filled</b> in <b>${item.form_builder_id?.name}</b>`;
                break;
              case 'APPROVED':
                description = `A form data is <b>approved</b> by <span style="color: #409eff">${item.user_details.name}</span> in <b>${item.form_builder_id?.name}</b>`;
                break;
              case 'REJECTED':
                description = `A form is <b>rejected</b> by <span style="color: #409eff">${item.user_details.name}</span> in <b>${item.form_builder_id?.name}</b>`;
                break;
              default:
                description = 'Action in Form Builder';
                break;
            }
            break;
          case 'NOTIFICATION':
            if (item.entity_data_id && item.entity_data_id) {
              description = `Email successfully sent to an entity data in <b>${item.entity_id?.name}</b>.`;
            } else if (item.form_builder_data_id) {
              description = `Email successfully sent to a form data in <b>${item.form_builder_id?.name}</b>.`;
            }
            break;
          default:
            description = '';
            break;
        }
        return description;
      },
      hideChatPopup() {
        this.isChatPopupShow = false;
      },
      sendMessageToParent() {
        this.$store.commit('navigationOpen/setIsOpen', !this.getIsOpen, {
          root: true,
        });
        this.$emit('open:sidebar', !this.isOpen);
      },
      async fetchUserData() {
        if (this.getActiveWorkspace) {
          this.currentWorkspace = this.getActiveWorkspace;
          this.currentWorkspaceId = this.currentWorkspace.company_id;
          this.userWorkspaceList = this.getWorkspaceList.filter((e) => e?.company_id?._id);

          let info = await this.updateIndividualWorkspace(this.getActiveWorkspace);
          this.currentWorkspace = info.currentWorkspace;
          this.userWorkspaceList = info.userWorkspaceList.filter((e) => e?.company_id?._id);

          this.selectLoad = false;
        } else {
          await this.handleLogoutInfo();
        }
      },
      async updateUserData() {
        this.loading = true;
        await this.$store.dispatch('auth/fetchUsersWithEmail', this.getAuthenticatedUser.email);
        if (this.getWorkspaceList) {
          let info = await this.updateIndividualWorkspace(this.getActiveWorkspace);
          this.currentWorkspace = info.currentWorkspace;
          this.userWorkspaceList = info.userWorkspaceList.filter((e) => e?.company_id?._id);
        } else {
          this.userWorkspaceList = [];
        }
      },
      async changeRole() {
        this.loading = true;
        let timerInterval;
        Swal.fire({
          title: '',
          html: 'Validation process is going on.It will take few seconds.Please wait....',
          timer: 15000,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        });
        await this.$store.dispatch('auth/fetchUsersWithEmail', this.getAuthenticatedUser.email);

        if (this.getWorkspaceList) {
          let presentWorkSpace = this.getWorkspaceList.filter((u) => {
            if (
              u.company_id == this.currentWorkspace.company_id ||
              u.company_id?._id == this.currentWorkspace.company_id
            ) {
              return u;
            }
          });
          let selectedWorkSpace = this.getWorkspaceList.filter((u) => {
            if (
              u.company_id == this.currentWorkspaceId ||
              u.company_id?._id == this.currentWorkspaceId
            ) {
              return u;
            }
          });
          if (
            presentWorkSpace &&
            presentWorkSpace.length &&
            presentWorkSpace[0] &&
            presentWorkSpace[0].status === 'ACTIVE'
          ) {
            if (selectedWorkSpace && selectedWorkSpace.length) {
              if (selectedWorkSpace[0] && selectedWorkSpace[0].status === 'ACTIVE') {
                Swal.close();
                await this.changeWorkspaceRole(this.currentWorkspaceId, this.activeRole);
              } else if (selectedWorkSpace[0] && selectedWorkSpace[0].status === 'HOLD') {
                Swal.close();
                await this.activateAccount();
              } else if (selectedWorkSpace[0] && selectedWorkSpace[0].status === 'INACTIVE') {
                await this.revertOldWorkspace(
                  'This workspace is in inactive state. Please contact administrator'
                );
              } else {
                await this.revertOldWorkspace(
                  'This workspace is not found in your records . Please verify once '
                );
              }
            } else {
              await this.revertOldWorkspace(
                'This workspace is not found in your records . Please verify once '
              );
            }
          } else if (
            presentWorkSpace &&
            presentWorkSpace.length &&
            presentWorkSpace[0] &&
            presentWorkSpace[0].status === 'HOLD'
          ) {
            await this.handleLogoutInfo(
              'This workspace is in Hold state. Please contact to  administrator.Please re-login.'
            );
          } else if (
            presentWorkSpace &&
            presentWorkSpace.length &&
            presentWorkSpace[0] &&
            presentWorkSpace[0].status === 'INACTIVE'
          ) {
            await this.handleLogoutInfo(
              'This workspace is in inactive state. Please contact to administrator.Please re-login.'
            );
          }
        }
      },

      async ChangeAccount() {
        this.loadingText = 'Checking for access...';
        this.loading = true;
        let timerInterval;
        Swal.fire({
          title: '',
          html: 'Validation process is going on.It will take few seconds.Please wait....',
          timer: 15000,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        });
        await this.$store.dispatch('auth/fetchUsersWithEmail', this.getAuthenticatedUser.email);

        if (this.getWorkspaceList) {
          let presentWorkSpace = this.getWorkspaceList.filter((u) => {
            if (
              u.company_id == this.currentWorkspace.company_id ||
              u.company_id?._id == this.currentWorkspace.company_id
            ) {
              return u;
            }
          });
          let selectedWorkSpace = this.getWorkspaceList.filter((u) => {
            if (
              u.company_id == this.currentWorkspaceId ||
              u.company_id?._id == this.currentWorkspaceId
            ) {
              return u;
            }
          });
          if (
            presentWorkSpace &&
            presentWorkSpace.length &&
            presentWorkSpace[0] &&
            presentWorkSpace[0].status === 'ACTIVE'
          ) {
            if (selectedWorkSpace && selectedWorkSpace.length) {
              if (selectedWorkSpace[0] && selectedWorkSpace[0].status === 'ACTIVE') {
                Swal.close();
                await this.changeWorkspace(this.currentWorkspaceId, true);
                this.loading = false;
              } else if (selectedWorkSpace[0] && selectedWorkSpace[0].status === 'HOLD') {
                Swal.close();
                await this.activateAccount();
                this.loading = false;
              } else if (selectedWorkSpace[0] && selectedWorkSpace[0].status === 'INACTIVE') {
                await this.revertOldWorkspace(
                  'This workspace is in inactive state. Please contact administrator'
                );
              } else {
                await this.revertOldWorkspace(
                  'This workspace is not found in your records . Please verify once '
                );
              }
            } else {
              await this.revertOldWorkspace(
                'This workspace is not found in your records . Please verify once '
              );
            }
          } else if (
            presentWorkSpace &&
            presentWorkSpace.length &&
            presentWorkSpace[0] &&
            presentWorkSpace[0].status === 'HOLD'
          ) {
            await this.handleLogoutInfo(
              'This workspace is in Hold state. Please contact to  administrator.Please re-login.'
            );
          } else if (
            presentWorkSpace &&
            presentWorkSpace.length &&
            presentWorkSpace[0] &&
            presentWorkSpace[0].status === 'INACTIVE'
          ) {
            await this.handleLogoutInfo(
              'This workspace is in inactive state. Please contact to administrator.Please re-login.'
            );
          }
        }
        this.loading = false;
      },
      async activateAccount() {
        this.loading = false;
        Swal.close();
        Swal.fire({
          title: 'Are you sure?',
          text: 'This workspace is in hold state. Do you want to activate it?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loadingText = 'activating your workspace';
            this.loading = true;
            try {
              await this.$store.dispatch('auth/verifyAndSwitch', this.currentWorkspaceId);
              if (this.getAuthenticationStatus) {
                this.loading = false;
                Swal.close();
                await this.changeWorkspace(this.currentWorkspaceId);
              } else {
                await this.revertOldWorkspace('Failed to active the account');
              }
            } catch (HoldError) {
              console.log('activeAccount', HoldError);
              Swal.close();
              await this.revertOldWorkspace('');
            }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.currentWorkspaceId = this.currentWorkspace.company_id;
          }
        });
      },

      async revertOldWorkspace(msg = '') {
        this.loading = false;
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: msg ? msg : 'Something went wrong!',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.currentWorkspaceId = this.currentWorkspace.company_id;
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.currentWorkspaceId = this.currentWorkspace.company_id;
          }
        });
      },
      loadComponent(value, text) {
        console.log({ value, text });
        this.loadingText = text || 'Switching your workspace...';
        this.loading = value;
      },
      async loadingAlert() {
        this.loadingText = 'Switching your workspace...';
        this.loading = true;
        Swal.close();
      },
      async getCompanyUserTypeList() {
        if (this.getActiveWorkspace && this.getActiveWorkspace?.company_id) {
          try {
            this.userTypes = await fetchUserTypes();
            this.getUserTypeEmailsList(this.userTypes);
          } catch (err) {
            this.$notify.error({
              title: 'Error',
              message: err,
            });
          }
        }
      },
      replaceSvgImages() {
        document.querySelectorAll('img.svg').forEach((img) => {
          const imgID = img.id;
          const imgClass = img.className;
          const imgURL = img.getAttribute('src');

          fetch(imgURL)
            .then((response) => response.text())
            .then((data) => {
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(data, 'image/svg+xml');
              const svg = xmlDoc.querySelector('svg');
              if (!svg) return;

              if (imgID) svg.setAttribute('id', imgID);
              if (imgClass) svg.setAttribute('class', `${imgClass} replaced-svg`);
              svg.removeAttribute('xmlns:a');

              for (let attr of img.attributes) {
                if (!['src', 'class', 'id'].includes(attr.name)) {
                  svg.setAttribute(attr.name, attr.value);
                }
              }

              img.replaceWith(svg);
            })
            .catch((err) => {
              console.error(`Error loading SVG from ${imgURL}:`, err);
            });
        });
      },
    },
    created() {
      this.lastSelectedWorkspaceId = this.getActiveWorkspace.company_id;
      this.$bus.$on('load-component', this.loadComponent);
      this.$bus.$on('fetch-global-filter-entity-data', this.fetchGlobalFilterEntityData);
    },
    beforeDestroy() {
      this.$bus.$off('load-component', this.loadComponent);
      this.$bus.$off('fetch-global-filter-entity-data', this.fetchGlobalFilterEntityData);
      document.removeEventListener('click', this.handleClickOutside);
    },
  };
</script>

<style>
  Explain .logo {
    display: flex;

    align-items: center;

    justify-content: center;

    height: 50px;
  }

  @media (max-width: 768px) {
    .logo {
      justify-content: center;
    }
  }

  .topbar-icons {
    display: flex;

    gap: 12px;

    align-items: center;
  }

  @media (max-width: 768px) {
    .topbar-icons {
      gap: 8px;
    }
  }

  .topbar {
    display: flex;

    align-items: center;

    justify-content: space-between;

    padding: 8px 16px;
  }

  .logo {
    display: flex;

    align-items: center;

    font-size: 18px;
  }

  .topbar-icons {
    display: flex;

    gap: 16px;
  }

  .hamburger {
    display: block;
  }

  @media (max-width: 768px) {
    .hamburger {
      display: none;
    }

    .logo {
      justify-content: center;

      font-size: 20px;
    }

    .topbar-icons {
      gap: 10px;
    }
  }

  @media (max-width: 920px) {
    .dashboard {
      padding-left: unset;
      padding: 0.5rem;
      margin-top: 15px;
    }
  }
</style>

<style lang="scss" scoped>
  .swal2-backdrop-show {
    backdrop-filter: blur(8px);
  }

  .scrollbar {
    scrollbar-width: thin;
    overflow-y: scroll;
  }

  @media (max-width: 972px) {
    .logout-list-menu {
      padding: 0 0.35em;
    }
  }

  .dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #000000;
    margin-right: 5px;
    margin-left: 5px;

    span {
      display: none;
    }
  }

  .mobile-switch {
    transform: scale(0.75);
    transform-origin: left center;
  }

  .mobile-column {
    flex-direction: column !important;
    align-items: flex-start !important;

    span,
    a {
      font-size: 12px !important;
      margin-bottom: 4px;
      padding: 4px;
    }
  }

  .active-option {
    background-color: #f0f8ff;
    font-weight: bold;
    color: #007bff;
  }

  .custom-dropdown {
    position: absolute;
    left: -70px;
    background: white;
    border: 1px solid #ccc;
    z-index: 999;
    margin-top: 5px;
    width: 170px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    max-height: 200px;
    overflow-y: scroll;
    scrollbar-width: thin;
  }

  .dropdown-option {
    padding: 8px 12px;
    cursor: pointer;
  }

  .dropdown-option:hover {
    background-color: #f0f0f0;
  }

  .dropdown-trigger {
    position: relative;
  }

  .custom-dropdown .dropdown-option.disabled {
    color: gray;
    pointer-events: none;
  }

  body.modal-open {
    height: 100vh;
    //overflow-y: hidden;
  }

  .top-navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0 !important;
    // background: #1b487e;
    // color: #ffffff;
    transform: scale(1);
    padding: 0px 40px 0px 20px;

    @media (max-width: 972px) {
      height: 4em !important;
    }

    @media (max-width: 768px) {
      padding: 5px 16px 5px 16px !important;
    }

    .top-navbar-left-menu {
      ul {
        display: flex;
        align-items: center;

        li {
          &:not(:last-child) {
            margin-right: 25px;
          }
        }
      }
    }

    .top-navbar-right-menu {
      .logout-dropdown {
        float: right;
        position: relative;
        display: flex;
        align-items: center;

        .alert-icon {
          position: relative;
          margin-right: 35px;

          .alert-count {
            position: absolute;
            top: -12px;
            right: -6px;

            span {
              background: var(--brand-500);
              font-size: 0.8em;
              border: 1px solid var(--brand-500);
              color: #ffffff;
              padding: 2px;
              width: 9px;
              height: 9px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
            }
          }

          img {
            width: 22px;
            margin-top: 5px;
          }
        }

        .top-search {
          .el-input__inner {
            border-radius: 3px;
            background: rgba(236, 245, 255, 0.1);
            font-size: 0.9rem;
            line-height: 2;
            width: calc(100% - 22px);
            border-color: rgba(236, 245, 255, 0.2);
            height: 38px;
            color: #ffffff;

            &:focus {
              border-color: #1b487e;
            }
          }

          .el-input__icon {
            line-height: 27px !important;
          }
        }

        .el-dropdown {
          font-size: 15px;
          padding-right: 0;
          display: flex;
          align-items: center;

          button {
            padding: 0;
            margin: 0;
            background: transparent;
            border: none;
          }

          &:hover {
            cursor: pointer;
          }

          .user-image {
            img {
              width: 36px;
              height: 36px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }

          .icon-block {
            display: flex;
            align-items: flex-start;
          }

          .icon-text {
            letter-spacing: 0.2px;

            .dropdown-arrow {
              img {
                width: 10px;
              }
            }
          }

          .user-profile-image {
            img {
              width: 25px;
            }
          }
        }
      }
    }

    .toggle-menu-animation {
      .hidden {
        visibility: hidden;
      }

      button {
        cursor: pointer;
      }

      button:focus {
        outline: 0;
      }

      .burger-button {
        position: relative;
        height: 30px;
        width: 30px;
        display: block;
        z-index: 60;
        border: 0;
        border-radius: 0;
        background-color: transparent;
        pointer-events: all;
        display: flex !important;
        justify-content: center;
        align-items: center;

        img {
          margin-left: auto !important;
        }
      }

      .burger-bar {
        background-color: var(--topbar-text-color);
        position: absolute;
        top: 50%;
        right: 6px;
        left: 6px;
        height: 2px;
        width: auto;
        margin-top: -1px;
        transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
        opacity: 1;
      }

      .burger-bar--1 {
        -webkit-transform: translateY(-6px);
        transform: translateY(-8px);
      }

      .burger-bar--3 {
        transform: translateY(8px);
      }

      #burger.active .burger-bar--1 {
        transform: rotate(45deg);
      }

      #burger.active .burger-bar--2 {
        opacity: 0;
      }

      #burger.active .burger-bar--3 {
        transform: rotate(-45deg);
      }
    }
  }

  .card:hover .img-top {
    display: inline;
  }

  .notification-wrapper {
    position: relative;
    display: inline-block;
    cursor: pointer;

    .number-on-bell {
      position: absolute;
      top: -6px;
      right: -10px;
      background-color: white;
      color: black;
      font-size: 11px;
      padding: 2px 6px;
      border-radius: 4px;
      z-index: 1;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
      line-height: 120% !important;
      font-weight: 500 !important;
    }
  }

  .badge {
    position: absolute;
    top: -6px;
    right: -10px;
    background-color: white;
    color: black;
    font-size: 11px;
    padding: 2px 6px;
    border-radius: 4px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
    z-index: 1;
    line-height: 120% !important;
    font-weight: 500 !important;
  }

  .icon {
    color: #333;
  }

  .notification-popup {
    margin-right: -40px;
    border-radius: 5px;
    margin-right: -40px;
    box-shadow:
      0px 41px 17px 0px rgba(0, 0, 0, 0.01),
      -14px -4px 14px 0px rgba(0, 0, 0, 0.03),
      0px 10px 10px 0px rgba(0, 0, 0, 0.05),
      0px 3px 6px 0px rgba(0, 0, 0, 0.06),
      0px 0px 0px 0px rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    top: 58px;
    z-index: 10000;
    position: absolute;
    left: 20%;

    @media (min-width: 400px) and (max-width: 768px) {
      .arrow {
        display: none;
      }

      left: -30%;
      max-width: 350px;
    }

    @media (max-width: 400px) {
      width: 250px;
      left: -20%;
    }

    .notifications-bottom-row {
      padding: 11px 0px;
      text-align: center;
      background-color: white;
      border-radius: 0 0 12px 12px;

      a {
        color: #0085ff;
        cursor: pointer;
        font-size: clamp(12px, 0.72vw, 14px);
      }
    }

    .load-more {
      padding: 10px 10px;
      text-align: center;

      a {
        color: #409eff;
        cursor: pointer;
      }
    }

    .load-more-element {
      cursor: pointer;
    }

    .notifications-top-row {
      display: flex;
      justify-content: space-between;
      padding: 10px 10px;
      border-color: #d8dde3;

      span {
        color: #141414;
        font-weight: 500;
        font-size: clamp(13px, 0.83vw, 16px);
      }

      a {
        color: #409eff;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    .first-row-select {
      border-bottom: none;
      padding: 5px 10px 0px 10px;
    }

    .arrow {
      width: 0px;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 0px;
      border-bottom: 10px solid white;
      margin-left: 62%;
      margin-top: 14px;
    }

    .el-scrollbar {
      border-radius: 0 0 12px 12px;
    }

    .list-group-flush {
      padding: 0px;
      background: white;
      border-radius: 12px 12px 0 0 !important;

      & > .list-group-item {
        border-width: 0 0 1px;

        &:first-child {
          border-top: 0 !important;
        }
      }
    }

    .noNotifications {
      margin-left: 40%;
      display: grid;
      gap: 0px;

      .img-text {
        margin-left: 5px;
        color: #1f1f1f;
      }
    }

    .notifcation-item {
      cursor: pointer;
      padding: 8px 12px;
      display: grid;
      grid-template-columns: 2.75em 1fr;
      gap: 8px;
      border-color: #d8dde3;
      transition: all 0.2s ease-in-out;

      &:first-child {
        border-top: none !important;
      }

      @media (max-width: 499.98px) {
        padding: 5px 5px !important;
      }

      .item-avatar {
        border-radius: 50%;
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border: 1px solid var(--brand-500);
        background-color: transparent;
        color: var(--brand-500);

        .unread {
          position: absolute;
          z-index: 10000;
          width: 7px;
          height: 7px;
          top: 6px;
          left: 34px;
          border-radius: 8px;
          background: var(--brand-500);
        }
      }

      .item-body {
        display: flex;
        justify-content: space-between;

        p {
          font-size: clamp(12px, 0.72vw, 14px);

          span {
            b {
              font-weight: 500 !important;
            }
          }
        }

        .name {
          font-style: normal;
          margin-bottom: 0;
          font-weight: 500;
        }

        .date-time {
          font-style: normal;
          text-align: right;
          color: #696f8c !important;
          font-size: clamp(10px, 0.625vw, 12px);
        }

        .doc-name {
          font-weight: 500;
        }
      }

      &:hover {
        background-color: #f7f7f7;
      }
    }
  }

  .notification-popup2 {
    display: flex;
    flex-direction: column;
    left: 26%;
    min-width: 350px;
    background-color: var(--card-color) !important;
  }

  .workspace-wrapper {
    position: relative;
    margin-right: 16px;
    cursor: pointer;

    @media (max-width: 500px) {
      max-width: 130px;
    }

    @media (max-width: 400px) {
      max-width: 100px;
      margin-right: 20px;
    }
  }

  .top-navbar-right-menu {
    @media (max-width: 500px) {
      .user-image {
        &.profile-image {
          display: none;
        }
      }
    }

    .user-role {
      padding-left: 27px;
      margin-top: 5%;
      color: var(--topbar-text-color);
      margin-top: 5%;

      @media (max-width: 500px) {
        text-align: left;
        padding-left: 0px;
      }
    }
  }

  .el-message-box__wrapper {
    .el-message-box {
      @media (max-width: 420px) {
        width: 95% !important;
      }
    }
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: var(--brand-200);
    color: var(--brand-500) !important;
  }

  .el-dropdown-menu .el-dropdown-menu__item svg path {
    fill: var(--black-700) !important;
  }

  .el-select-dropdown__item.selected {
    color: var(--brand-500);
    font-weight: 700;
  }

  .topbar-appearence {
    height: 45px;
  }
</style>
<style scoped lang="scss">
  .ApplyFont ::v-deep .el-input__inner {
    font-family: var(--font-family);
  }

  .arrow-stylee {
    color: var(--topbar-text-color) !important;
  }

  .hamburger {
    display: block;
  }

  @media (max-width: 768px) {
    .hamburger {
      display: none;
    }

    .mob {
      transform-origin: center top;

      z-index: 2011;

      position: fixed;

      top: -13px !important;

      width: 100%;

      height: 90vh;

      left: 0 !important;
    }
  }

  .circle-name {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background-color: white;

    border: 2px solid #409eff;

    color: black;
    font-weight: 400;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .circle-name.active {
    border-color: red;
  }

  .dropdown-header {
    font-size: 13px;

    font-weight: bold;

    padding: 8px 15px;

    background-color: #f0f4f8;

    color: #3a87ad;

    border-bottom: 1px solid #e0e6ed;
  }

  .el-dropdown-item {
    display: flex;

    align-items: center;

    font-size: 14px;

    padding: 10px 15px;

    transition:
      background 0.3s,
      color 0.3s;
  }

  .el-dropdown-item:hover {
    background-color: #ecf5ff;

    color: #409eff;
  }

  .el-dropdown-item .icon,
  .el-dropdown-item img.icon {
    margin-right: 8px;

    width: 14px;

    height: 14px;

    opacity: 0.85;
  }

  .dropdown-profile-block {
    display: flex;

    align-items: center;

    justify-content: space-between;

    padding: 12px 15px;

    background-color: #fff;

    gap: 12px;

    position: relative;
  }

  .profile-details {
    flex: 1;

    display: flex;

    flex-direction: column;

    justify-content: center;
  }

  .profile-full-name {
    font-weight: 600;

    font-size: 14px;

    color: #1a1a1a;

    margin-bottom: 2px;
  }

  .profile-role {
    font-size: 12px;

    color: #888;
  }

  .logout-icon {
    font-size: 18px;

    color: #ff4d4f;

    cursor: pointer;

    padding-left: 8px;
  }

  .logout-icon:hover {
    color: #d9363e;
  }

  .el-dropdown-menu.mob {
    max-height: 90vh;

    overflow-y: auto;

    overflow-x: hidden;

    padding-bottom: 10px;

    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .el-dropdown-item {
    display: flex;

    align-items: center;

    font-size: 14px;

    padding: 10px 16px;

    line-height: 1.4;

    white-space: nowrap;
  }

  .el-dropdown-item .icon,
  .el-dropdown-item img.icon {
    width: 16px !important;

    height: 16px !important;

    margin-right: 10px;

    object-fit: contain;

    display: inline-block;

    vertical-align: middle;
  }

  @media (max-height: 650px) {
    .el-dropdown-menu.mob {
      max-height: 90vh;
    }
  }

  .el-dropdown-item .icon,
  .el-dropdown-item i.icon,
  .el-dropdown-item img.icon {
    width: 16px;

    height: 16px;

    margin-right: 8px;

    vertical-align: middle;

    display: inline-block;

    font-size: 16px;

    line-height: 1;
  }

  .el-dropdown-item i.fa,
  .el-dropdown-item i.el-icon-cpu {
    line-height: 16px;

    margin-top: 1px;
  }

  .dropdown-profile-block {
    position: relative;
  }

  .logout-icon {
    position: absolute;

    top: 8px;

    right: 10px;

    font-size: 18px;

    color: #ff4d4f;

    cursor: pointer;
  }

  .logout-icon:hover {
    color: #d9363e;
  }

  .icon_mobile {
    width: 16px !important;

    height: 16px !important;

    margin-right: 8px !important;

    vertical-align: middle !important;

    opacity: 0.85;

    object-fit: contain !important;
  }

  .select-pair-wrapper {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    align-items: center;
    background: #f9f9f9;
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    margin: 10px 0;
  }

  .select-group-horizontal {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 220px;
    flex: 1;
  }

  .select-icon {
    font-size: 20px;
    color: #333;
    width: 28px;
    text-align: center;
  }

  .select-field {
    flex: 1;
    min-width: 180px;
    font-size: 15px;
    background-color: white;
    border-radius: 4px;
    box-shadow: inset 0 0 0 1px #dcdfe6;
    transition: box-shadow 0.2s ease;
  }

  .el-select-dropdown__item {
    font-size: 15px !important;
  }

  .select-field:hover {
    box-shadow: inset 0 0 0 1px #409eff;
  }

  .select-field:focus-within {
    box-shadow: inset 0 0 0 2px #409eff;
  }

  @media (max-width: 768px) {
    .select-pair-wrapper {
      flex-direction: column;
      padding: 10px;
    }

    .select-group-horizontal {
      width: 100%;
    }

    .select-field {
      width: 100%;
    }
  }
</style>
